export default __webpack_public_path__ + "static/media/Shake.52097c69.svg";